import {
  takeEvery,
  call,
  put,
  all,
  fork,
  select,
  delay
} from "redux-saga/effects";
import {
  actionCreators,
  LOGIN_WITH_GOOGLE,
  LOG_OUT,
  CREATE_ACCOUNT,
  LOGIN_WITH_EMAIL_AND_PASSWORD
} from "./action";
import firebase from "firebase";
import { reduxSagaFirebase } from "../../rootFirebase";
import { actionCreators as alertActionCreators } from "../Alert/action";

const authProvider = new firebase.auth.GoogleAuthProvider();

export function* onloginWithGoogleSaga() {
  yield put(
    alertActionCreators.alertAddMessage({
      severity: "info",
      message: "logowanie..."
    })
  );


  try {
    let credential;

    if (('standalone' in window.navigator)
      && window.navigator.standalone) {
        credential = yield call(
        reduxSagaFirebase.auth.signInWithRedirect,
        authProvider
      );
    }else{
      credential = yield call(
        reduxSagaFirebase.auth.signInWithRedirect,
        authProvider
      );
    }



    const user = yield call(
      reduxSagaFirebase.auth.signInWithCredential,
      credential
    );
    yield put(actionCreators.putCredentials(credential));
    yield put(actionCreators.putUser(user));

    yield put(
      alertActionCreators.alertAddMessage({
        severity: "info",
        message: "zalogowany pomyślnie"
      })
    );

    yield delay(2000);
    yield put(alertActionCreators.alertAddMessage(null));
  } catch (error) {
    yield put(
      alertActionCreators.alertAddMessage({
        severity: "error",
        message: error.message
      })
    );
  }
}

export function* onLoginWithEmailAndPasswordSaga(action) {
  const email = action.payload.email;
  const password = action.payload.password;

  yield put(
    alertActionCreators.alertAddMessage({
      severity: "info",
      message: "logowanie..."
    })
  );

  try {
    const user = yield call(
      reduxSagaFirebase.auth.signInWithEmailAndPassword,
      email,
      password
    );
    yield put(actionCreators.putUser(user));

    yield put(
      alertActionCreators.alertAddMessage({
        severity: "info",
        message: "zalogowany pomyślnie"
      })
    );

    yield delay(2000);
    yield put(alertActionCreators.alertAddMessage(null));
  } catch (error) {
    yield put(
      alertActionCreators.alertAddMessage({
        severity: "error",
        message: error.message
      })
    );
  }
}

export function* onLogOutSaga() {
  try {
    const data = yield call(reduxSagaFirebase.auth.signOut);
    yield put(actionCreators.putCredentials(null));
    yield localStorage.removeItem("user");
    yield put(actionCreators.putUser(null));
  } catch (error) {
    yield put(
      alertActionCreators.alertAddMessage({
        severity: "error",
        message: error.message
      })
    );
  }
}

function* onCreateAccountSaga(action) {
  const email = action.payload.email;
  const password = action.payload.password;
  try {
    const user = yield call(
      reduxSagaFirebase.auth.createUserWithEmailAndPassword,
      email,
      password
    );
    yield put(actionCreators.putUser(user));
    yield put(
      alertActionCreators.alertAddMessage({
        severity: "info",
        message: "zalogowany pomyślnie"
      })
    );

    yield delay(2000);
    yield put(alertActionCreators.alertAddMessage(null));
  } catch (error) {
    yield put(
      alertActionCreators.alertAddMessage({
        severity: "error",
        message: error.message
      })
    );
  }
}

export function* logoutSaga() {
  yield takeEvery(LOG_OUT, onLogOutSaga);
}

export function* loginWithGoogleSaga() {
  yield takeEvery(LOGIN_WITH_GOOGLE, onloginWithGoogleSaga);
}

export function* createAccountSaga() {
  yield takeEvery(CREATE_ACCOUNT, onCreateAccountSaga);
}

export function* loginWithEmailAndPasswordSaga() {
  yield takeEvery(LOGIN_WITH_EMAIL_AND_PASSWORD, onLoginWithEmailAndPasswordSaga);
}

export function* loginSaga() {
  yield all([
    fork(loginWithGoogleSaga),
    fork(logoutSaga),
    fork(createAccountSaga),
    fork(loginWithEmailAndPasswordSaga)
  ]);
}
